
const testingCommisionaAtionTypes = {
    NEXT_PAGE: 'NEXT_PAGE',
    PREVIOUS_PAGE: 'PREVIOUS_PAGE',
    SAVE_PAGE: 'SAVE_PAGE',
    //set basic detauls 
    SET_BASIC_DETAILS_FIELDS: 'SET_BASIC_DETAILS_FIELDS',
    RESET_BASIC_DETAILS_FIELDS: 'RESET_BASIC_DETAILS_FIELDS',
    SET_BASIC_DETAILS_MANDATORY_FIELDS: 'SET_BASIC_DETAILS_MANDATORY_FIELDS',
    IS_SAVE_BASICDETAILS: 'IS_SAVE_BASICDETAILS',
    //set others 
    SET_OTHERS_DETAILS_FIELDS: 'SET_OTHERS_DETAILS_FIELDS',
    RESET_OTHERS_DETAILS_FIELDS: 'RESET_OTHERS_DETAILS_FIELDS',
    IS_SAVE_OTHERSDETAILS: 'IS_SAVE_OTHERSDETAILS',
    EDIT_PAGE: 'EDIT_PAGE',
    SET_TC_FIELD_VALUES:'SET_TC_FIELD_VALUES',
    RESET_TC_FIELD_VALUES:'RESET_TC_FIELD_VALUES',

    // Add other action types here as needed
};

export default testingCommisionaAtionTypes;